import ReactDOM from 'react-dom/client';
import App from 'App';

import 'fonts.css';
import 'style.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
